import styled from '@emotion/styled';
import { TextSpan } from 'app/typography';
import { FC } from 'react';
import css from '@emotion/css';

const Wrapper = styled(TextSpan)<{ isEmpty?: boolean; isRole?: boolean }>`
  display: inline-block;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  ${({ isEmpty, isRole }) =>
    isEmpty
      ? css`
          border: 1px dashed var(--color-border-medium);
          line-height: 18px;
        `
      : css`
          background-color: ${isRole
            ? 'var(--color-viz-cat-4-primary)'
            : 'var(--color-viz-cat-2-primary)'};
          color: var(--color-font-white);
          font-size: 11px;
          line-height: 22px;
        `};
  text-align: center;
  vertical-align: middle;
`;

function getInitials(fullName?: string | null) {
  const initials = (fullName || '')
    .split('(')[0] // remove any (email) suffix
    .trim()
    .split(/\s+/)
    .map((part) => part.charAt(0).toUpperCase());

  if (initials.length === 0) {
    return '';
  }
  if (initials.length === 1) {
    return initials[0];
  }
  return initials[0] + initials[initials.length - 1];
}

const Avatar: FC<{
  fullName?: string | null;
  isEmpty?: boolean;
  isRole?: boolean;
}> = ({ fullName, ...others }) => {
  return <Wrapper {...others}>{getInitials(fullName)}</Wrapper>;
};

export default Avatar;
